<script>
import Breadcrumb from '@/components/global/breadcrumb.vue';
import InputText from 'primevue/inputtext';
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "whatsapp-links",
  data() {
    return {
      breadcrumbs: [
        { name: 'الرئيسية', path: '/' },
        { name: 'لينكات الواتساب', path: '/whatsapp_links' },
      ],
      // ── QR / Device Status ──
      qrStatus: 'loading',   // loading | connecting | working | disconnected
      qrImage: null,
      qrNeedsScan: false,
      qrLastUpdated: null,
      qrLoading: false,
      qrPollingTimer: null,
      restarting: false,
      deletingSession: false,
      // ── WhatsApp Links ──
      first_prep_boys: '',
      first_prep_girls: '',
      second_prep_boys: '',
      second_prep_girls: '',
      third_prep_boys: '',
      third_prep_girls: '',
      first_sec_boys: '',
      first_sec_girls: '',
      second_sec_boys: '',
      second_sec_girls: '',
      third_sec_boys: '',
      third_sec_girls: '',
      formSending: false,
    };
  },
  components: {
    Breadcrumb,
    InputText
  },
  computed: {
    qrStatusLabel() {
      const labels = {
        loading:      'جاري التحميل...',
        connecting:   'في انتظار المسح',
        working:      'تم ربط واتساب بنجاح',
        disconnected: 'غير متصل',
      };
      return labels[this.qrStatus] || this.qrStatus;
    },
    qrStatusClass() {
      return {
        'text-success fw-bold': this.qrStatus === 'working',
        'text-warning':         this.qrStatus === 'connecting',
        'text-danger':          this.qrStatus === 'disconnected',
        'text-secondary':       this.qrStatus === 'loading',
      };
    },
  },
  methods: {
    async fetchQrCode() {
      this.qrLoading = true;
      try {
        const res = await axios.get('/whatsapp/qr');
        const data = res.data?.data ?? {};
        this.qrStatus      = data.status ?? 'disconnected';
        this.qrNeedsScan   = data.needs_scan === true;
        this.qrImage       = this.qrNeedsScan ? data.qr : null;
        this.qrLastUpdated = new Date().toLocaleTimeString('ar-EG');
      } catch {
        this.qrStatus = 'disconnected';
        this.qrImage  = null;
      } finally {
        this.qrLoading = false;
      }
    },
    startQrPolling() {
      this.fetchQrCode();
      this.qrPollingTimer = setInterval(() => {
        if (this.qrStatus !== 'working') {
          this.fetchQrCode();
        } else {
          this.stopQrPolling();
        }
      }, 5000);
    },
    stopQrPolling() {
      if (this.qrPollingTimer) {
        clearInterval(this.qrPollingTimer);
        this.qrPollingTimer = null;
      }
    },
    refreshQr() {
      this.stopQrPolling();
      this.startQrPolling();
    },
    async restartSession() {
      const result = await Swal.fire({
        title: 'إعادة تشغيل الجلسة',
        text: 'هل تريد إعادة تشغيل جلسة الواتساب؟ سيتم إنشاء QR جديد إذا لم يكن متصلاً.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#25d366',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'نعم، إعادة التشغيل',
        cancelButtonText: 'إلغاء',
      });
      if (!result.isConfirmed) return;

      this.restarting = true;
      this.stopQrPolling();
      try {
        const res = await axios.post('/whatsapp/restart');
        const data = res.data?.data ?? res.data ?? {};
        if (data.status) {
          this.qrStatus    = data.status;
          this.qrNeedsScan = data.needs_scan === true;
          this.qrImage     = this.qrNeedsScan ? (data.qr ?? null) : null;
        } else {
          this.qrStatus    = 'connecting';
          this.qrNeedsScan = false;
          this.qrImage     = null;
        }
        this.qrLastUpdated = new Date().toLocaleTimeString('ar-EG');
        Swal.fire({ icon: 'success', title: 'تم', text: 'تم إعادة التشغيل بنجاح', timer: 1500, showConfirmButton: false });
      } catch (e) {
        Swal.fire({ icon: 'error', title: 'خطأ', text: e.response?.data?.message || 'فشل إعادة التشغيل' });
      } finally {
        this.restarting = false;
        this.startQrPolling();
      }
    },
    async deleteSession() {
      const result = await Swal.fire({
        title: 'حذف الجلسة',
        html: 'هل أنت متأكد من حذف جلسة الواتساب؟<br><b>سيلزم مسح QR جديد بعد الحذف.</b>',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'نعم، احذف الجلسة',
        cancelButtonText: 'إلغاء',
      });
      if (!result.isConfirmed) return;

      this.deletingSession = true;
      this.stopQrPolling();
      try {
        await axios.delete('/whatsapp/session');
        this.qrStatus    = 'disconnected';
        this.qrImage     = null;
        this.qrNeedsScan = false;
        this.qrLastUpdated = new Date().toLocaleTimeString('ar-EG');
        Swal.fire({ icon: 'success', title: 'تم الحذف', text: 'تم حذف الجلسة — يرجى مسح QR جديد', timer: 2000, showConfirmButton: false });
      } catch (e) {
        Swal.fire({ icon: 'error', title: 'خطأ', text: e.response?.data?.message || 'فشل حذف الجلسة' });
      } finally {
        this.deletingSession = false;
        this.startQrPolling();
      }
    },
    getData() {
      axios
          .get('/whatsapp_links')
          .then((response) => {
            const data = response.data.data;

            this.first_prep_boys = data.first_prep_boys || '';
            this.first_prep_girls = data.first_prep_girls || '';
            this.second_prep_boys = data.second_prep_boys || '';
            this.second_prep_girls = data.second_prep_girls || '';
            this.third_prep_boys = data.third_prep_boys || '';
            this.third_prep_girls = data.third_prep_girls || '';
            this.first_sec_boys = data.first_sec_boys || '';
            this.first_sec_girls = data.first_sec_girls || '';
            this.second_sec_boys = data.second_sec_boys || '';
            this.second_sec_girls = data.second_sec_girls || '';
            this.third_sec_boys = data.third_sec_boys || '';
            this.third_sec_girls = data.third_sec_girls || '';
          })
          .catch((error) => {
            Swal.fire({
              position: "center",
              icon: "error",
              title: error.response.data.message,
            });
          });
    },
    sendForm() {
      const formData = new FormData();
      formData.append('first_prep_boys', this.first_prep_boys);
      formData.append('first_prep_girls', this.first_prep_girls);
      formData.append('second_prep_boys', this.second_prep_boys);
      formData.append('second_prep_girls', this.second_prep_girls);
      formData.append('third_prep_boys', this.third_prep_boys);
      formData.append('third_prep_girls', this.third_prep_girls);
      formData.append('first_sec_boys', this.first_sec_boys);
      formData.append('first_sec_girls', this.first_sec_girls);
      formData.append('second_sec_boys', this.second_sec_boys);
      formData.append('second_sec_girls', this.second_sec_girls);
      formData.append('third_sec_boys', this.third_sec_boys);
      formData.append('third_sec_girls', this.third_sec_girls);

      this.formSending = true;

      axios
          .post('/update_whatsapp_links', formData)
          .then((response) => {
            this.formSending = false;
            Swal.fire({
              position: "center",
              icon: "success",
              title: "تم التحديث بنجاح",
            });
          })
          .catch((error) => {
            this.formSending = false;
            Swal.fire({
              position: "center",
              icon: "error",
              title: error.response.data.message,
            });
          });
    },
  },
  mounted() {
    this.startQrPolling();
    this.getData();
  },
  beforeUnmount() {
    this.stopQrPolling();
  },
}
</script>

<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="form-page">

    <!-- ══════════════════════ قسم ربط الجهاز ══════════════════════ -->
    <div class="form-card mb-4">
      <div class="form-card__header">
        <div class="form-card__header-icon"><i class="pi pi-qrcode"></i></div>
        <div>
          <span class="form-card__title">ربط جهاز واتساب</span>
          <p class="form-card__subtitle">امسح الـ QR Code لربط واتساب بالنظام</p>
        </div>
        <div class="d-flex gap-2 ms-auto flex-wrap">
          <button type="button" class="btn btn-outline-secondary btn-sm" @click="refreshQr" :disabled="qrLoading || restarting || deletingSession">
            <i class="pi" :class="qrLoading ? 'pi-spin pi-spinner-dotted' : 'pi-refresh'"></i>
            تحديث QR
          </button>
          <button type="button" class="btn btn-outline-warning btn-sm" @click="restartSession" :disabled="qrLoading || restarting || deletingSession">
            <i class="pi" :class="restarting ? 'pi-spin pi-spinner-dotted' : 'pi-power-off'"></i>
            {{ restarting ? 'جاري...' : 'إعادة التشغيل' }}
          </button>
          <button type="button" class="btn btn-outline-danger btn-sm" @click="deleteSession" :disabled="qrLoading || restarting || deletingSession">
            <i class="pi" :class="deletingSession ? 'pi-spin pi-spinner-dotted' : 'pi-trash'"></i>
            {{ deletingSession ? 'جاري...' : 'حذف الجلسة' }}
          </button>
        </div>
      </div>
      <div class="form-card__body text-center">

        <!-- حالة working -->
        <div v-if="qrStatus === 'working'" class="py-4">
          <i class="pi pi-check-circle text-success" style="font-size: 3rem;"></i>
          <p class="mt-2 fw-bold text-success fs-5">تم ربط واتساب بنجاح ✓</p>
        </div>

        <!-- QR Code -->
        <div v-else-if="qrNeedsScan && qrImage" class="py-3">
          <img :src="'data:image/png;base64,' + qrImage" alt="QR Code" style="width: 220px; height: 220px;" />
          <p class="mt-2 text-warning fw-bold">امسح الكود بتطبيق واتساب</p>
        </div>

        <!-- connecting أو disconnected بدون QR -->
        <div v-else class="py-4">
          <i class="pi pi-wifi text-warning" style="font-size: 2.5rem;"></i>
          <p class="mt-2" :class="qrStatusClass">{{ qrStatusLabel }}</p>
        </div>

        <div class="text-muted small mt-1" v-if="qrLastUpdated">
          آخر تحديث: {{ qrLastUpdated }}
        </div>
      </div>
    </div>
    <!-- ═══════════════════════════════════════════════════════════ -->

    <div class="form-page-header">
      <div class="form-page-header__icon">
        <i class="pi pi-whatsapp"></i>
      </div>
      <div class="form-page-header__text">
        <h1 class="form-page-header__title">روابط الواتساب</h1>
        <p class="form-page-header__subtitle">روابط مجموعات الواتساب لكل صف وجنس</p>
      </div>
    </div>

    <div class="container-fluid">
      <form @submit.prevent="sendForm()">
        <!-- المرحلة الإعدادية -->
        <div class="form-card">
          <div class="form-card__header">
            <div class="form-card__header-icon"><i class="pi pi-users"></i></div>
            <div>
              <span class="form-card__title">المرحلة الإعدادية</span>
              <p class="form-card__subtitle">الصفوف من الأول إلى الثالث إعدادي</p>
            </div>
          </div>
          <div class="form-card__body">
            <!-- أولى إعدادي -->
            <div class="grade-group">
              <div class="grade-group-label">
                <i class="pi pi-tag"></i>
                الصف الأول الإعدادي
              </div>
              <div class="grade-row">
                <div class="form-field">
                  <label class="field-label">
                    <span class="gender-tag gender-tag--boys"><i class="pi pi-mars"></i> بنين</span>
                  </label>
                  <div class="wa-field">
                    <i class="wa-field__icon pi pi-whatsapp"></i>
                    <InputText v-model="first_prep_boys" placeholder="https://chat.whatsapp.com/..." dir="ltr" class="w-100" />
                  </div>
                </div>
                <div class="form-field">
                  <label class="field-label">
                    <span class="gender-tag gender-tag--girls"><i class="pi pi-venus"></i> بنات</span>
                  </label>
                  <div class="wa-field">
                    <i class="wa-field__icon pi pi-whatsapp"></i>
                    <InputText v-model="first_prep_girls" placeholder="https://chat.whatsapp.com/..." dir="ltr" class="w-100" />
                  </div>
                </div>
              </div>
            </div>
            <!-- ثانية إعدادي -->
            <div class="grade-group">
              <div class="grade-group-label">
                <i class="pi pi-tag"></i>
                الصف الثاني الإعدادي
              </div>
              <div class="grade-row">
                <div class="form-field">
                  <label class="field-label">
                    <span class="gender-tag gender-tag--boys"><i class="pi pi-mars"></i> بنين</span>
                  </label>
                  <div class="wa-field">
                    <i class="wa-field__icon pi pi-whatsapp"></i>
                    <InputText v-model="second_prep_boys" placeholder="https://chat.whatsapp.com/..." dir="ltr" class="w-100" />
                  </div>
                </div>
                <div class="form-field">
                  <label class="field-label">
                    <span class="gender-tag gender-tag--girls"><i class="pi pi-venus"></i> بنات</span>
                  </label>
                  <div class="wa-field">
                    <i class="wa-field__icon pi pi-whatsapp"></i>
                    <InputText v-model="second_prep_girls" placeholder="https://chat.whatsapp.com/..." dir="ltr" class="w-100" />
                  </div>
                </div>
              </div>
            </div>
            <!-- ثالثة إعدادي -->
            <div class="grade-group" style="margin-bottom: 0;">
              <div class="grade-group-label">
                <i class="pi pi-tag"></i>
                الصف الثالث الإعدادي
              </div>
              <div class="grade-row">
                <div class="form-field">
                  <label class="field-label">
                    <span class="gender-tag gender-tag--boys"><i class="pi pi-mars"></i> بنين</span>
                  </label>
                  <div class="wa-field">
                    <i class="wa-field__icon pi pi-whatsapp"></i>
                    <InputText v-model="third_prep_boys" placeholder="https://chat.whatsapp.com/..." dir="ltr" class="w-100" />
                  </div>
                </div>
                <div class="form-field">
                  <label class="field-label">
                    <span class="gender-tag gender-tag--girls"><i class="pi pi-venus"></i> بنات</span>
                  </label>
                  <div class="wa-field">
                    <i class="wa-field__icon pi pi-whatsapp"></i>
                    <InputText v-model="third_prep_girls" placeholder="https://chat.whatsapp.com/..." dir="ltr" class="w-100" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- المرحلة الثانوية -->
        <div class="form-card">
          <div class="form-card__header">
            <div class="form-card__header-icon"><i class="pi pi-users"></i></div>
            <div>
              <span class="form-card__title">المرحلة الثانوية</span>
              <p class="form-card__subtitle">الصفوف من الأول إلى الثالث ثانوي</p>
            </div>
          </div>
          <div class="form-card__body">
            <!-- أولى ثانوي -->
            <div class="grade-group">
              <div class="grade-group-label">
                <i class="pi pi-tag"></i>
                الصف الأول الثانوي
              </div>
              <div class="grade-row">
                <div class="form-field">
                  <label class="field-label">
                    <span class="gender-tag gender-tag--boys"><i class="pi pi-mars"></i> بنين</span>
                  </label>
                  <div class="wa-field">
                    <i class="wa-field__icon pi pi-whatsapp"></i>
                    <InputText v-model="first_sec_boys" placeholder="https://chat.whatsapp.com/..." dir="ltr" class="w-100" />
                  </div>
                </div>
                <div class="form-field">
                  <label class="field-label">
                    <span class="gender-tag gender-tag--girls"><i class="pi pi-venus"></i> بنات</span>
                  </label>
                  <div class="wa-field">
                    <i class="wa-field__icon pi pi-whatsapp"></i>
                    <InputText v-model="first_sec_girls" placeholder="https://chat.whatsapp.com/..." dir="ltr" class="w-100" />
                  </div>
                </div>
              </div>
            </div>
            <!-- ثانية ثانوي -->
            <div class="grade-group">
              <div class="grade-group-label">
                <i class="pi pi-tag"></i>
                الصف الثاني الثانوي
              </div>
              <div class="grade-row">
                <div class="form-field">
                  <label class="field-label">
                    <span class="gender-tag gender-tag--boys"><i class="pi pi-mars"></i> بنين</span>
                  </label>
                  <div class="wa-field">
                    <i class="wa-field__icon pi pi-whatsapp"></i>
                    <InputText v-model="second_sec_boys" placeholder="https://chat.whatsapp.com/..." dir="ltr" class="w-100" />
                  </div>
                </div>
                <div class="form-field">
                  <label class="field-label">
                    <span class="gender-tag gender-tag--girls"><i class="pi pi-venus"></i> بنات</span>
                  </label>
                  <div class="wa-field">
                    <i class="wa-field__icon pi pi-whatsapp"></i>
                    <InputText v-model="second_sec_girls" placeholder="https://chat.whatsapp.com/..." dir="ltr" class="w-100" />
                  </div>
                </div>
              </div>
            </div>
            <!-- ثالثة ثانوي -->
            <div class="grade-group" style="margin-bottom: 0;">
              <div class="grade-group-label">
                <i class="pi pi-tag"></i>
                الصف الثالث الثانوي
              </div>
              <div class="grade-row">
                <div class="form-field">
                  <label class="field-label">
                    <span class="gender-tag gender-tag--boys"><i class="pi pi-mars"></i> بنين</span>
                  </label>
                  <div class="wa-field">
                    <i class="wa-field__icon pi pi-whatsapp"></i>
                    <InputText v-model="third_sec_boys" placeholder="https://chat.whatsapp.com/..." dir="ltr" class="w-100" />
                  </div>
                </div>
                <div class="form-field">
                  <label class="field-label">
                    <span class="gender-tag gender-tag--girls"><i class="pi pi-venus"></i> بنات</span>
                  </label>
                  <div class="wa-field">
                    <i class="wa-field__icon pi pi-whatsapp"></i>
                    <InputText v-model="third_sec_girls" placeholder="https://chat.whatsapp.com/..." dir="ltr" class="w-100" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <button type="submit" class="btn-submit" :disabled="formSending">
            <i class="pi pi-spin pi-spinner-dotted" v-if="formSending"></i>
            <i class="pi pi-check" v-else></i>
            {{ formSending ? 'جاري الحفظ...' : 'حفظ الروابط' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>